import { IS_LANDSCAPE } from '~/data/constants';
import LaunchMobile from './LaunchMobile';
import LaunchWeb from './LaunchWeb';

export default IS_LANDSCAPE ? LaunchWeb : LaunchMobile;
